// extracted by mini-css-extract-plugin
export default {"statusDiv":"run-tag_statusDiv__7tcnh","pClass":"run-tag_pClass__p1CzE"};